export const downloadFile = (file: File | string, fileName: string) => {
  const url = typeof file === 'string' ? file : URL.createObjectURL(file);

  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
};
